export const SDK_STATE = Object.freeze({
    UNLOADED: 'UNLOADED',
    INITIALIZING: 'INITIALIZING',
    READY: 'READY',
    FAILED: 'FAILED'
})

export const SESSION_STATE = Object.freeze({
    IDLE: 'IDLE',
    PRECHECK: 'PRECHECK',
    MEASURING: 'MEASURING',
    DISPATCHING: 'DISPATCHING',
    QUEUING: 'QUEUING',
    STARTING: 'STARTING',
    PLAYING: 'PLAYING',
    STOPPING: 'STOPPING',
    ERROR: 'ERROR'
})

const TRANSITIONS = Object.freeze({
    [SESSION_STATE.IDLE]: [SESSION_STATE.PRECHECK],
    [SESSION_STATE.PRECHECK]: [SESSION_STATE.MEASURING, SESSION_STATE.STOPPING, SESSION_STATE.ERROR],
    [SESSION_STATE.MEASURING]: [SESSION_STATE.DISPATCHING, SESSION_STATE.STOPPING, SESSION_STATE.ERROR],
    [SESSION_STATE.DISPATCHING]: [SESSION_STATE.QUEUING, SESSION_STATE.STARTING, SESSION_STATE.STOPPING, SESSION_STATE.ERROR],
    [SESSION_STATE.QUEUING]: [SESSION_STATE.STARTING, SESSION_STATE.STOPPING, SESSION_STATE.ERROR],
    [SESSION_STATE.STARTING]: [SESSION_STATE.PLAYING, SESSION_STATE.STOPPING, SESSION_STATE.ERROR],
    [SESSION_STATE.PLAYING]: [SESSION_STATE.STOPPING, SESSION_STATE.ERROR],
    [SESSION_STATE.ERROR]: [SESSION_STATE.STOPPING],
    [SESSION_STATE.STOPPING]: [SESSION_STATE.IDLE]
})

export function assertTransition (from, to) {
    if (!TRANSITIONS[from] || !TRANSITIONS[from].includes(to)) {
        throw new Error(`非法的云游戏状态转换: ${from} -> ${to}`)
    }
    return to
}

export function isActiveAttempt (callbackAttemptId, activeAttemptId) {
    return callbackAttemptId === activeAttemptId
}
